import { useAppOffers } from '../../application/pwa/useAppOffers';
import InstallOfferCard from './InstallOfferCard';

/**
 * The one place in the app that may ask the reader for anything.
 *
 * At most one card, at the foot of the garage, and nowhere else — never on the
 * splash, which is a brand moment with nothing to decide, and never on a car,
 * which is immersive and has one action pinned to its foot already.
 *
 * One offer today because there is one thing to offer: Legends has no account,
 * no notifications and no backend, so the only question it ever asks is whether
 * to keep the app. The component exists all the same rather than the garage
 * rendering the card directly — the moment there is a second offer, "which one,
 * and whether either" becomes a decision, and this is where it will already be.
 *
 * WHETHER to ask is `useAppOffers`. This draws the answer, which is why it has
 * no state of its own.
 */
export default function AppOffers() {
    const { offer, installActionKey, installHowToKey, acceptInstall, dismissInstall } = useAppOffers();

    if (offer !== 'install') {
        return null;
    }

    return (
        <InstallOfferCard
            actionKey={installActionKey}
            howToKey={installHowToKey}
            onInstall={acceptInstall}
            onDismiss={dismissInstall}
        />
    );
}
